import React from "react";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import BackButton from "./BackButton";
import IconButton from "@material-ui/core/IconButton";
import Selections from "./Selections";
import Modal from "./Modal";
import AddGroup from "./AddGroup";
import { connect } from "react-redux";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";

class Result extends React.Component {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  onAddButtonClick = () => {};

  render() {
    let htmlContent = (
      <div>
        {/* // <GridContainer> */}
        {/* // <GridItem xs={12} sm={12}> */}
        <div
          style={{
            paddingLeft: "20px",
            paddingTop: "30px",
            paddingRight: "20px"
          }}
        >
          <AddGroup />
        </div>
        {/* </GridItem> */}
        {/* </GridContainer> */}
      </div>
    );
    return <React.Fragment>{htmlContent}</React.Fragment>;
  }
}

const mapStateToProps = state => ({
  cust_countSegment: state.cust_countSegment,
  cust_tillSqlSelectionArrSegment: state.cust_tillSqlSelectionArrSegment,
  cust_afterSqlSelectionArrSegment: state.cust_afterSqlSelectionArrSegment
});

export default connect(mapStateToProps)(Result);



// WEBPACK FOOTER //
// ./src/views/Audiences/CSegmentQueryBuilder/Result.jsx